import { api } from '@/services/api';

export type JudgeAgentStatus = 'ONLINE' | 'OFFLINE';

export interface JudgeAgentCapabilities {
  languages: string[];
  checkers: string[];
  maxConcurrency: number;
}

export interface JudgeAgent {
  id: string;
  name: string;
  status: JudgeAgentStatus;
  lastHeartbeatAt?: string;
  runningJobs: number;
  capabilities: JudgeAgentCapabilities;
  createdAt: string;
  updatedAt: string;
}

export interface JudgeAvailability {
  available: boolean;
  message: string;
}

export async function getJudgeAvailability() {
  const response = await api.get<JudgeAvailability>('/judge-agents/availability');
  return response.data;
}

export async function listJudgeAgents() {
  const response = await api.get<JudgeAgent[]>('/admin/judge-agents');
  return response.data;
}
